import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../..";
import topTost from "../../utils/topTost";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
import Content2Header from "./Content2Header";
import { fetchFormData } from "../../utils/options";
const EditNotes = () => {
  const [notes, setNotes] = useState([{ text: "", image: null }]);
  const [details, setDetails] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!token) navigate("/");
  }, []);


  const getNotesPath = (fullUrl) => {
  if (!fullUrl) return "";
  try {
    const url = new URL(fullUrl);
    return url.pathname.replace(/^\/+/, ""); 
  } catch {
    return fullUrl;
  }
};

const handleRemoveNote = async (item, index) => {
  const isBase64 = item.image?.startsWith("data:");
  if (item.image && !isBase64) {

    const path = getNotesPath(item.image);
    await removeContent(path, index);
  } else {
  topTost({
  title: "Content removed. Click Update to permanently remove this content.",
  icon: "info",
});
    setNotes((prev) => prev.filter((_, i) => i !== index));
  }
};


  // Convert File -> Base64
  const toBase64 = (file) => {
    return new Promise((resolve) => {
      if (!file) return resolve(null);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });
  };

  // Update text
  const updateNoteText = (index, value) => {
    const updated = [...notes];
    updated[index].text = value;
    setNotes(updated);
  };

  // Update image
  const updateFile = async (index, file) => {
    const base64 = await toBase64(file);
    const updated = [...notes];
    updated[index].image = base64;
    setNotes(updated);
  };

  // Add new note
  const addNote = () =>
    setNotes([...notes, { id: Date.now(), text: "", image: null }]);


  //remove content api

  const removeContent = async (urlPath, index) => {
  

    const form = new FormData();
    form.append("url", urlPath);

    try {
      const result = await fetchFormData(
        "content/remove-ContentFile",
        form,
        "POST"
      );

      if (result?.success || result?.code === 200) {
       topTost({
  title: "Content removed. Click Update to permanently remove this content.",
  icon: "info",
});

        
        setNotes((prev) => prev.filter((_, i) => i !== index));
      } else {
        topTost({
          title: "Failed to remove Note",
          icon: "error",
        });
      }
    } catch (error) {
      console.log(error);
      topTost({ title: "Something went wrong", icon: "error" });
    }
  };
  // content by id
  const contentbyId = async () => {
    try {
      const response = await fetch(`${BaseUrl}contentbyid/${id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const data = result?.result?.data;
      setDetails(data);
      const resultArr = result?.result?.data?.notes;

      if (resultArr.length > 0) {
        setNotes(
          resultArr.map((n) => ({
            text: n.text || "",
            image: n.image_url || "",
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id) {
      contentbyId();
    }
  }, []);
  // Submit Notes
  const updateNotes = async () => {
    const payload = {
      id: id,
      Notes: notes, // EXACT structure your backend expects
    };

    console.log("Sending Payload:", payload);

    try {
      const response = await fetch(`${BaseUrl}update/content/notes`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("API Response:", result);

      if (result?.result?.code === 200) {
        topTost({ title: result?.result?.message, icon: "success" });
        setTimeout(() => {
          navigate("/master/topic-list");
        }, 600);

        return;
      } else {
        topTost({ title: result.message || "Update failed", icon: "error" });
      }
    } catch (error) {
      console.log(error);
      topTost({ title: "Something went wrong", icon: "error" });
    }
  };

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            {" "}
            <Content2Header />
          </PageHeader>
          <div className="main-content">
          
              <div className="card mb-4 fw-bold">
                  <div className="card-header text-white" style={{backgroundColor:"#0e606e"}}>
    Edit Notes
  </div>
                <div className="card-body">
                  <div className="row "  >
                 
                    <div className="col-md-6 mb-2">
                      <strong>Course:</strong> {details.course_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Semester:</strong> {details.semester_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Subject:</strong> {details.subject_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Chapter:</strong> {details.chapter_name || "-"}
                    </div>
                    <div className="col-md-6 mb-2">
                      <strong>Title:</strong> {details.title || "-"}
                    </div>
                     <div className="col-md-6 mb-2">
                      <strong>description:</strong> {details.description || "-"}
                    </div>
                  </div>
                </div>
           
            </div>

          
<div className="card mb-4">
  <div className="card-body">

    <div className="table-responsive">
      <table className="table table-bordered align-middle">
        <thead  style={{
    display: "table-header-group",
    backgroundColor: "#f1f1f1",
    color: "#000",
    fontWeight: "600",
  }}>
          <tr>
            <th style={{ width: "50%" }}>Notes</th>
            <th style={{ width: "20%" }}>Image </th>
            <th style={{ width: "20%" }}>Preview</th>
            <th style={{ width: "10%" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {notes.map((item, index) => (
            <tr key={item.id || index}>

              {/* Notes Text */}
              <td>
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Enter notes..."
                  value={item.text}
                  onChange={(e) => updateNoteText(index, e.target.value)}
                />
              </td>

              {/* Image Upload */}
              <td>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => updateFile(index, e.target.files[0])}
                />
              </td>

              {/* Preview */}
              <td className="text-center">
                {item.image ? (
                  <img
                    src={item.image}
                    alt="preview"
                    className="img-thumbnail"
                    style={{ height: "80px", objectFit: "cover" }}
                  />
                ) : (
                  <span className="text-muted">No Image</span>
                )}
              </td>

              {/* Action */}
              <td className="text-center">
                {(item.text || item.image) && (
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => handleRemoveNote(item, index)}
                  >
                    Remove
                  </button>
                )}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Add Note Button */}
   

  </div>
</div>

 
      <button
        type="button"
        className="btn btn-outline-primary btn-sm mt-2"
        onClick={addNote}
      >
        + Add More
      </button>
 
            <button className="btn btn-success mt-3" onClick={updateNotes}>
              Update Notes
            </button>
          </div>
        </div>
      </main>
    </>
  );
};

export default EditNotes;
